import * as React from 'react';
import { connect } from 'react-redux';
import { Alert, Button, FormGroup, Input, Label } from 'reactstrap';
import { Dispatch } from 'redux';
import { GlobalState } from '../../../actions';
import { Section, SectionHeading } from '../../../common/Section';
import { accountUserSettingChangePassword, accountUserSettingSetPasswordChangeMessage } from '../actions';
import {
    accountUserSettingsPasswordChangeMessageSelector,
    accountUserSettingsPasswordChangeStateSelector
} from '../selectors';

export type PasswordChangeState = 'ok' | 'error' | undefined;

interface Props {
    passwordChangeMessage: string;
    passwordChangeState: PasswordChangeState;
    onUpdatePassword: (oldPwd: string, newPwd: string) => void;
    onSetMessage: (msg: string, state: PasswordChangeState) => void;
    onDismissMessage: () => void;
}

interface State {
    oldPassword: string;
    newPassword: string;
    newPassword2: string;
}

class ChangePassword extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = { oldPassword: '', newPassword: '', newPassword2: '' };

        this.onChange = this.onChange.bind(this);
        this.onUpdate = this.onUpdate.bind(this);
    }

    public onChange(ev: React.FormEvent<HTMLInputElement>) {
        this.setState(Object.assign({}, this.state, { [ev.currentTarget.name]: ev.currentTarget.value }));
    }

    public onUpdate() {
        if (!this.state.newPassword || !this.state.newPassword2) {
            this.props.onSetMessage('Kennwörter dürfen nicht leer sein.', 'error');
        } else if (this.state.newPassword.length < 3) {
            this.props.onSetMessage('Kennwörter müssen mindestens 3 Zeichen enthalten.', 'error');
        } else if (this.state.newPassword !== this.state.newPassword2) {
            this.props.onSetMessage('Kennwörter sind nicht identisch.', 'error');
        } else {
            this.props.onSetMessage('', undefined);
            this.setState({ oldPassword: this.state.oldPassword, newPassword: '', newPassword2: '' });
            this.props.onUpdatePassword(this.state.oldPassword, this.state.newPassword);
        }
    }

    public render() {
        return (
            <Section>
                <SectionHeading>Kennwort ändern</SectionHeading>
                {(this.props.passwordChangeState === 'error' || this.props.passwordChangeState === 'ok') && (
                    <Alert
                        color={this.props.passwordChangeState === 'error' ? 'danger' : 'success'}
                        toggle={this.props.onDismissMessage}
                    >
                        {this.props.passwordChangeMessage}
                    </Alert>
                )}
                <FormGroup>
                    <Label>altes Kennwort</Label>
                    <Input
                        type="password"
                        name="oldPassword"
                        placeholder="altes Kennwort"
                        value={this.state.oldPassword}
                        onChange={this.onChange}
                    />
                </FormGroup>
                <FormGroup>
                    <Label>neues Kennwort</Label>
                    <Input
                        type="password"
                        name="newPassword"
                        placeholder="neues Kennwort"
                        value={this.state.newPassword}
                        onChange={this.onChange}
                    />
                </FormGroup>
                <FormGroup>
                    <Label>neues Kennwort wiederholen</Label>
                    <Input
                        type="password"
                        name="newPassword2"
                        placeholder="neues Kennwort wiederholen"
                        value={this.state.newPassword2}
                        onChange={this.onChange}
                    />
                </FormGroup>
                <Button onClick={this.onUpdate}>Kennwort ändern</Button>
            </Section>
        );
    }
}

const mapStateToProps = (state: GlobalState) => {
    return {
        passwordChangeMessage: accountUserSettingsPasswordChangeMessageSelector(state),
        passwordChangeState: accountUserSettingsPasswordChangeStateSelector(state)
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        onUpdatePassword: (oldPwd: string, newPwd: string) => {
            dispatch(accountUserSettingChangePassword({ oldPwd, newPwd }));
        },
        onSetMessage: (msg: string, state: PasswordChangeState) => {
            dispatch(accountUserSettingSetPasswordChangeMessage({ msg, state }));
        },
        onDismissMessage: () => {
            dispatch(accountUserSettingSetPasswordChangeMessage({ msg: '', state: undefined }));
        }
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ChangePassword);
